export default __webpack_public_path__ + "static/case01-a22f35425ee0b1051cef9a684fd56d21.webp";